import { combineReducers } from 'redux';
import user from './user.reducer';
import organization from './organization.reducer';
import tube from './tube.reducer';
import language from './language.reducer';
import login from './login.reducer';
import register from './register.reducer';
var authReducers = combineReducers({
    user: user,
    login: login,
    register: register,
    tube: tube,
    language: language,
    organization: organization,
});
export default authReducers;



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/reducers/index.ts
// module id = 1462
// module chunks = 81